import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class RescheduleAppointmentDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public rescheduleAsync(appointmentId: number, needCancelAppointment: boolean, timeout: Promise<any>): Promise<any> {
    return this.httpClient.getJsonAsync('RescheduleAppointments/SetAppointmentInReschedule', { appointmentId, needCancelAppointment }, timeout, false);
  }
  public Prevent24HoursReschudling(appointmentId: number, timeout: Promise<any>): Promise<any> {
    return this.httpClient.getJsonAsync('Planner/Prevent24HoursReschudling', { appointmentId }, timeout, false);
  }
  public deactivateReschedule(appointmentId: number, timeout: Promise<any>): Promise<boolean> {
    return this.httpClient.postJsonAsync('RescheduleAppointments/DeactivateReschedule', appointmentId, timeout);
  }
}
